export default __webpack_public_path__ + "static/media/Rectangle 4184.9b483d68.svg";